module.exports = __webpack_public_path__ + "img/newlogo.6a981b24.png";